import { Flex } from 'antd';

import { DescriptionWrapper, IconWrapper, TitleWrapper, Wrapper } from './QuizOptionModal.styles';

type Props = {
  icon: string | React.ReactNode;
  title: string;
  description: string;
  onClick: () => void;
};

export const QuizOptionModal: React.FC<Props> = ({ icon, title, description, onClick }) => {
  return (
    <Wrapper onClick={onClick}>
      <IconWrapper>{icon}</IconWrapper>
      <Flex vertical gap={8}>
        <TitleWrapper>{title}</TitleWrapper>
        <DescriptionWrapper>{description}</DescriptionWrapper>
      </Flex>
    </Wrapper>
  );
};
